import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from '../styles/components/Breadcrumbs.module.css';

const formatBreadcrumb = (path) => {
  // Capitalize first letter and remove dashes if any
  return path.charAt(0).toUpperCase() + path.slice(1).replace('-', ' ');
};

const Breadcrumbs = () => {
  const location = useLocation();

  // Get all path segments based on the current location (split by "/")
  const pathnames = location.pathname.split('/').filter((x) => x);

  return (
    <nav className={styles.breadcrumbs} aria-label="Breadcrumb">
      <ul className="flex space-x-2">
        {/* Link back to the home page */}
        <li>
          <Link to="/" className="text-blue-500 hover:underline">Home</Link>
        </li>

        {pathnames.map((value, index) => {
          // Dynamically build paths for each breadcrumb link
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;

          // Check if it’s the last breadcrumb (current page)
          const isLast = index === pathnames.length - 1;

          return (
            <li key={to} className="flex items-center">
              <span className="mx-2">/</span>
              {isLast ? (
                <span className="text-gray-500">{formatBreadcrumb(value)}</span> // No link for the current page
              ) : (
                <Link to={to} className="text-blue-500 hover:underline">
                  {formatBreadcrumb(value)}
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
